import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

import { utmKeys } from "@/constants/utm";
import { getReferrerUrl } from "@/utils/referrer";

const EXPIRATION_TIME = 30 * 60 * 1000; // 30 minutes

// Store UTM params and document.referrer in localStorage to prevent them from
// being lost when the user is signing up with email verification.
export const Utm = () => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const utmParams: Record<string, string> = {};
    for (const key of utmKeys) {
      const val = searchParams.get(key);
      if (val) utmParams[key] = val;
    }
    if (Object.keys(utmParams).length > 0) {
      const utmData = {
        params: utmParams,
        expires: Date.now() + EXPIRATION_TIME,
      };
      try {
        localStorage.setItem("layer_utm_params", JSON.stringify(utmData));
      } catch (error) {
        console.error(error);
      }
    }
  }, [searchParams]);

  useEffect(() => {
    // Capture the first-known referrer once per browser and never overwrite —
    // it is the landing-page referrer we want to attribute the signup to.
    try {
      const referrer = getReferrerUrl();
      if (!referrer) return;
      if (localStorage.getItem("layer_referrer_url")) return;
      localStorage.setItem("layer_referrer_url", referrer);
    } catch (error) {
      console.error(error);
    }
  }, []);

  return null;
};
